var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { IonCard, IonText } from '@ionic/react';
import styled from 'styled-components';
import { get } from 'lodash';
import '@ionic/react/css/core.css';
import { SubTitleComponent, TitleComponent } from '../commons/text';
const WrapperA = styled.a `
  display: flex;
  margin: ${(props) => (props.full ? 0 : '16px')};
  border-radius: ${(props) => (props.full ? 0 : '5px')};
  overflow: hidden;  
`;
const WrapperDiv = styled.div `
  display: flex;
  margin: ${(props) => (props.full ? 0 : '16px')};
  border-radius: ${(props) => (props.full ? 0 : '5px')};
  overflow: hidden;  
`;
const CardImage = styled.img `
  position: relative;
`;
const ContainerText = styled.div `
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  padding-top: 16px;
  padding-bottom: 5px;
`;
const Card = styled(IonCard) `
  box-shadow: none;
  width: auto;
  padding: 0;
  margin: 0;
  border-radius: 0;
`;
const Link = (_a) => {
    var { link, dev, full } = _a, props = __rest(_a, ["link", "dev", "full"]);
    return (link && !dev
        ? React.createElement(WrapperA, Object.assign({ full: full, href: link }, props))
        : React.createElement(WrapperDiv, Object.assign({ full: full }, props)));
};
export const Image = ({ title = null, description = null, picture = null, link = null, theme = null, dev = false, full = false, }) => (React.createElement(Card, { color: get(theme, 'color.background') },
    (title || description)
        && (React.createElement(ContainerText, null,
            React.createElement(IonText, null,
                React.createElement(TitleComponent, { theme: theme, title: title })),
            React.createElement(IonText, null,
                React.createElement(SubTitleComponent, { theme: theme, title: description })))),
    React.createElement(Link, { full: full, dev: dev, link: link },
        React.createElement(CardImage, { style: { width: '100%', height: '100%' }, src: picture, alt: "Buildings with tiled exteriors, lit by the sunset." }))));
